export default __webpack_public_path__ + "static/media/Martha 9781408339435.42141945.jpg";